<jha-nav [jhaIsHidden]="hideNav" jhaInitialState="collapsed">
  <jha-nav-button
    *ngIf="!loggedIn"
    jhaIconType="GoTo"
    jhaText="Log On"
    jhaTooltip="Log On"
    (click)="navigateTo('/login')">
  </jha-nav-button>

  <!-- Home -->
  <jha-nav-button
    *ngIf="loggedIn"
    jhaIconType="Home"
    jhaText="Home"
    jhaTooltip="Home"
    (click)="navigateTo('/home')">
  </jha-nav-button>

  <!-- Designer Studio -->
  <jha-nav-button
    *ngIf="loggedIn && hasPowerDocPermission"
    jhaIconType="AdobePDF"
    jhaText="Designer Studio"
    jhaTooltip="Designer Studio"
    (click)="navigateTo('/designer-studio')">
  </jha-nav-button>

  <!-- My App Store -->
  <jha-nav-button
    *ngIf="loggedIn && hasMyAppStorePermission"
    jhaIconType="ViewIcons"
    jhaText="My PowerFrame Apps"
    jhaTooltip="My PowerFrame Apps"
    (click)="navigateTo('/my-powerframe-apps')">
  </jha-nav-button>

  <!-- Audit Logs -->
  <jha-nav-button
    *ngIf="loggedIn && hasAuditLogsPermission"
    jhaIconType="Document"
    jhaText="Audit Logs"
    jhaTooltip="Audit Logs"
    (click)="navigateTo('audit-logs')">
  </jha-nav-button>

  <!-- User Management -->
  <jha-nav-button
    *ngIf="loggedIn && hasUserManagementPermission"
    jhaIconType="Person"
    jhaText="User Management"
    jhaTooltip="User Management"
    (click)="navigateTo('/users')">
  </jha-nav-button>

  <!-- Guest Users -->
  <jha-nav-button
    *ngIf="loggedIn && hasGuestUserPermission"
    jhaIconType="People"
    jhaText="Guest Users"
    jhaTooltip="Guest Users"
    (click)="navigateTo('/guest-users')">
  </jha-nav-button>

  <!-- Manage Institution -->
  <jha-nav-button
    *ngIf="loggedIn && hasInstManagementPermission"
    jhaIconType="Bank"
    jhaText="Institution"
    jhaTooltip="Manage Financial Institution"
    (click)="navigateTo('/institution')">
  </jha-nav-button>

  <!-- Roles -->
  <jha-nav-button
    *ngIf="loggedIn && hasUserManagementPermission"
    jhaIconType="PeopleGroup"
    jhaText="Roles"
    jhaTooltip="Roles"
    (click)="navigateTo('/roles')">
  </jha-nav-button>

  <!-- Service Configuration -->
  <!--   <jha-nav-button
    *ngIf="loggedIn && hasServiceConfigPermission"
    jhaIconType="Tools"
    jhaText="Service Configuration"
    jhaTooltip="Service Configuration"
    (click)="navigateTo('service-configuration')">
  </jha-nav-button> -->

  <!-- Configure Profile -->
  <jha-nav-button
    *ngIf="loggedIn && hasManageSymProfilePermission"
    jhaIconType="Document"
    jhaText="Configure Profile"
    jhaTooltip="Configure SymProfile"
    (click)="navigateTo('profile-configuration')">
  </jha-nav-button>

  <!-- Manage Projects -->
  <jha-nav-button
    *ngIf="loggedIn && hasManageProjectPermission"
    jhaIconType="ViewList"
    jhaText="Manage Project"
    jhaTooltip="Manage Project"
    (click)="navigateTo('manage-project')">
  </jha-nav-button>

  <!-- Release Notes -->
  <jha-nav-button
    *ngIf="loggedIn"
    jhaIconType="Verify"
    jhaText="Release Notes"
    jhaTooltip="Release Notes"
    (click)="navigateTo('/release-notes')">
  </jha-nav-button>
</jha-nav>
